import {Injectable} from '@angular/core';
import {AWSService} from '@app/app/shared/services/aws.service';
import {environment} from '@app/environments/environment';
import {HttpClient} from '@angular/common/http';

@Injectable()
export class CommandsService {
  private URL = '/commands';
  private URL2 = '/commands-updates';
  private URL_RAW = '/system-commands';

  constructor(private aws: AWSService, private http: HttpClient) {
    //
  }

  /**
   *
   * @returns {string}
   */
  private generateCommandId() {
    return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
  }

  private bc(parkId, commandId, params) {
    return {
      park: parkId,
      id: commandId,
      command: {
        jsonrpc: environment.jsonrpcVersion,
        method: 'command',
        params: params,
        id: commandId
      }
    };
  }

  /**
   *
   * @param commandId
   * @param parkId
   * @param isOn
   * @returns any
   */
  private buildCommand(commandId, parkId, isOn) {
    const params = {
      splashpad: {
        data: isOn ? 'stop' : 'start'
      }
    };

    return this.bc(parkId, commandId, params);
  }

  private buildCommand2(commandId, parkId, activators: {}) {
    const params = {};

    Object.keys(activators).forEach(function (activatorId) {
      params[activatorId] = {
        data: 'auto',
      };
    });

    return this.bc(parkId, commandId, params);
  }

  private buildCommand3(commandId, parkId, activatorId, mode) {
    const params = {
      [activatorId]: {
        data: mode
      }
    };

    return this.bc(parkId, commandId, params);
  }

  private buildCommand4(commandId, parkId, features: {}) {
    const params = {};

    Object.keys(features).forEach(function (featureId) {
      params[featureId] = {
        data: 'auto',
      };
    });

    return this.bc(parkId, commandId, params);
  }

  private buildCommand5(commandId, parkId, featureId, mode) {
    const params = {
      [featureId]: {
        data: mode
      }
    };

    return this.bc(parkId, commandId, params);
  }

  private buildCommand6(commandId, parkId, mode) {
    const params = {
      backwash: {
        data: mode
      }
    };

    return this.bc(parkId, commandId, params);
  }

  private buildCommand7(commandId, parkId, mode) {
    const params = {
      purge: {
        data: mode
      }
    };

    return this.bc(parkId, commandId, params);
  }

  private buildCommand8(commandId, parkId, rainDiverterId, mode) {
    const params = {
      [rainDiverterId]: {
        data: mode
      }
    };

    return this.bc(parkId, commandId, params);
  }

  private buildCommand9(commandId, parkId, bypassId, mode) {
    const params = {
      [bypassId]: {
        data: mode
      }
    };

    return this.bc(parkId, commandId, params);
  }

  private buildCommand10(commandId, parkId, featureLoopId, mode) {
    const params = {
      [featureLoopId]: {
        data: mode
      }
    };

    return this.bc(parkId, commandId, params);
  }

  private buildCommand11(commandId, parkId, filtrationLoopId, mode) {
    const params = {
      [filtrationLoopId]: {
        data: mode
      }
    };

    return this.bc(parkId, commandId, params);
  }

  private buildCommand12(commandId, parkId, params) {
    return {
      park: parkId,
      id: commandId,
      command: {
        jsonrpc: environment.jsonrpcVersion,
        method: 'settings',
        params: params,
        id: commandId
      }
    };
  }

  private buildCommand12a(commandId, parkId, params) {
    return {
      park: parkId,
      id: commandId,
      command: {
        jsonrpc: environment.jsonrpcVersion,
        method: 'settings_check',
        params: params,
        id: commandId
      }
    };
  }

  private buildCommand13(commandId, parkId, data) {
    return {
      park: parkId,
      id: commandId,
      command: {
        jsonrpc: environment.jsonrpcVersion,
        method: 'schedule',
        params: {
          add: data
        },
        id: commandId
      }
    };
  }

  private buildCommand14(commandId, parkId, data) {
    return {
      park: parkId,
      id: commandId,
      command: {
        jsonrpc: environment.jsonrpcVersion,
        method: 'schedule',
        params: {
          edit: data
        },
        id: commandId
      }
    };
  }

  private buildCommand15(commandId, parkId, data) {
    return {
      park: parkId,
      id: commandId,
      command: {
        jsonrpc: environment.jsonrpcVersion,
        method: 'schedule',
        params: {
          delete: data
        },
        id: commandId
      }
    };
  }

  private buildCommand16(commandId, parkId, params) {
    return {
      park: parkId,
      id: commandId,
      command: {
        jsonrpc: environment.jsonrpcVersion,
        method: 'task',
        params: params,
        id: commandId
      }
    };
  }

  private buildCommand17(commandId, parkId, taskId) {
    const params = {
      delete: {
        id: taskId
      }
    };

    return {
      park: parkId,
      id: commandId,
      command: {
        jsonrpc: environment.jsonrpcVersion,
        method: 'task',
        params: params,
        id: commandId
      }
    };
  }

  private buildCommand18(commandId, parkId, seqUrl) {
    const params = {sequences: seqUrl};

    return {
      park: parkId,
      id: commandId,
      command: {
        jsonrpc: environment.jsonrpcVersion,
        method: 'update',
        params: params,
        id: commandId
      }
    };
  }

  private buildCommand19(commandId, parkId) {
    const params = {};

    return {
      park: parkId,
      id: commandId,
      command: {
        jsonrpc: environment.jsonrpcVersion,
        method: 'shadow',
        params: params,
        id: commandId
      }
    };
  }

  private buildCommand20(commandId, parkId) {
    const params = {};

    return {
      park: parkId,
      id: commandId,
      command: {
        jsonrpc: environment.jsonrpcVersion,
        method: 'meta',
        params: params,
        id: commandId
      }
    };
  }

  private buildCommand21(commandId, parkId, data) {
    return {
      park: parkId,
      id: commandId,
      command: {
        jsonrpc: environment.jsonrpcVersion,
        method: 'led_time',
        params: data,
        id: commandId
      }
    };
  }

  private buildCommand21a(commandId, parkId, data) {
    const params = {
      new_time: data
    };

    return this.bc(parkId, commandId, params);
  }

  private buildRaw(parkId, commandId, command) {
    return {
      park: parkId,
      id: commandId,
      command: command
    };
  }

  private buildCommand22(commandId, parkId, data) {
    return {
      park: parkId,
      id: commandId,
      command: {
        jsonrpc: environment.jsonrpcVersion,
        method: 'sequence_settings',
        params: {
          add: data
        },
        id: commandId
      }
    };
  }

  private buildCommand23(commandId, parkId, data) {
    return {
      park: parkId,
      id: commandId,
      command: {
        jsonrpc: environment.jsonrpcVersion,
        method: 'sequence_settings',
        params: {
          edit: data
        },
        id: commandId
      }
    };
  }

  private buildCommand24(commandId, parkId, data) {
    return {
      park: parkId,
      id: commandId,
      command: {
        jsonrpc: environment.jsonrpcVersion,
        method: 'sequence_settings',
        params: {
          delete: data
        },
        id: commandId
      }
    };
  }

  public updateSettings(id, parkId, data) {
    const commandId = this.generateCommandId();
    const mqttTopic = `${id}/commands/${commandId}`;

    const body = this.buildCommand12(commandId, parkId, data);

    return this.run(mqttTopic, body);
  }

  public checkSettings(id, parkId, data) {
    const commandId = this.generateCommandId();
    const mqttTopic = `${id}/commands/${commandId}`;

    const body = this.buildCommand12a(commandId, parkId, data);

    return this.run(mqttTopic, body);
  }

  public updateTime(id, parkId, data) {
    const commandId = this.generateCommandId();
    const mqttTopic = `${id}/commands/${commandId}`;

    const body = this.buildCommand21a(commandId, parkId, data);

    return this.run(mqttTopic, body);
  }

  public updateLedTime(id, parkId, data) {
    const commandId = this.generateCommandId();
    const mqttTopic = `${id}/commands/${commandId}`;

    const body = this.buildCommand21(commandId, parkId, data);

    return this.run(mqttTopic, body);
  }

  public setFiltrationLoopMode(id, parkId, filtrationLoopId, mode) {
    const commandId = this.generateCommandId();
    const mqttTopic = `${id}/commands/${commandId}`;

    const body = this.buildCommand11(commandId, parkId, filtrationLoopId, mode);

    return this.run(mqttTopic, body);
  }

  public setFeatureLoopMode(id, parkId, featureLoopId, mode) {
    const commandId = this.generateCommandId();
    const mqttTopic = `${id}/commands/${commandId}`;

    const body = this.buildCommand10(commandId, parkId, featureLoopId, mode);

    return this.run(mqttTopic, body);
  }

  public setBypassMode(id, parkId, bypassId, mode) {
    const commandId = this.generateCommandId();
    const mqttTopic = `${id}/commands/${commandId}`;

    const body = this.buildCommand9(commandId, parkId, bypassId, mode);

    return this.run(mqttTopic, body);
  }

  public setRainDiverterMode(id, parkId, rainDiverterId, mode) {
    const commandId = this.generateCommandId();
    const mqttTopic = `${id}/commands/${commandId}`;

    const body = this.buildCommand8(commandId, parkId, rainDiverterId, mode);

    return this.run(mqttTopic, body);
  }

  public setRainSensorMode(id, parkId, rainSensorId, mode) {
    const commandId = this.generateCommandId();
    const mqttTopic = `${id}/commands/${commandId}`;

    const body = this.buildCommand8(commandId, parkId, rainSensorId, mode);

    return this.run(mqttTopic, body);
  }

  public setPurgeMode(id, parkId, mode) {
    const commandId = this.generateCommandId();
    const mqttTopic = `${id}/commands/${commandId}`;

    const body = this.buildCommand7(commandId, parkId, mode);

    return this.run(mqttTopic, body);
  }


  public setBackwashMode(id, parkId, mode) {
    const commandId = this.generateCommandId();
    const mqttTopic = `${id}/commands/${commandId}`;

    const body = this.buildCommand6(commandId, parkId, mode);

    return this.run(mqttTopic, body);
  }

  public setActivatorMode(id, parkId, activatorId, mode) {
    const commandId = this.generateCommandId();
    const mqttTopic = `${id}/commands/${commandId}`;

    const body = this.buildCommand3(commandId, parkId, activatorId, mode);

    return this.run(mqttTopic, body);
  }

  public setFeatureMode(id, parkId, featureId, mode) {
    const commandId = this.generateCommandId();
    const mqttTopic = `${id}/commands/${commandId}`;

    const body = this.buildCommand5(commandId, parkId, featureId, mode);

    return this.run(mqttTopic, body);
  }

  public createSchedule(id: string, parkId: string, params: {}) {
    const commandId = this.generateCommandId();
    const mqttTopic = `${id}/commands/${commandId}`;

    const body = this.buildCommand13(commandId, parkId, params);

    return this.run(mqttTopic, body);
  }

  public editSchedule(id: string, parkId: string, params: {}) {
    const commandId = this.generateCommandId();
    const mqttTopic = `${id}/commands/${commandId}`;

    const body = this.buildCommand14(commandId, parkId, params);

    return this.run(mqttTopic, body);
  }

  public deleteSchedule(id: string, parkId: string, params: {}) {
    const commandId = this.generateCommandId();
    const mqttTopic = `${id}/commands/${commandId}`;

    const body = this.buildCommand15(commandId, parkId, params);

    return this.run(mqttTopic, body);
  }

  public createSequence(id: string, parkId: string, params: {}) {
    const commandId = this.generateCommandId();
    const mqttTopic = `${id}/commands/${commandId}`;

    const body = this.buildCommand22(commandId, parkId, params);

    return this.run(mqttTopic, body);
  }

  public editSequence(id: string, parkId: string, params: {}) {
    const commandId = this.generateCommandId();
    const mqttTopic = `${id}/commands/${commandId}`;

    const body = this.buildCommand23(commandId, parkId, params);

    return this.run(mqttTopic, body);
  }

  public deleteSequence(id: string, parkId: string, params: {}) {
    const commandId = this.generateCommandId();
    const mqttTopic = `${id}/commands/${commandId}`;

    const body = this.buildCommand24(commandId, parkId, params);

    return this.run(mqttTopic, body);
  }

  public createOrEditTask(id: string, parkId: string, params: {}) {
    const commandId = this.generateCommandId();
    const mqttTopic = `${id}/commands/${commandId}`;

    const body = this.buildCommand16(commandId, parkId, params);

    return this.run(mqttTopic, body);
  }

  public deleteTask(id: string, parkId: string, taskId: string) {
    const commandId = this.generateCommandId();
    const mqttTopic = `${id}/commands/${commandId}`;

    const body = this.buildCommand17(commandId, parkId, taskId);

    return this.run(mqttTopic, body);
  }


  public updateSequences(id: string, parkId: string, seqUrl: string) {
    const commandId = this.generateCommandId();
    const mqttTopic = `${id}/updates/${commandId}`;

    const body = this.buildCommand18(commandId, parkId, seqUrl);

    return this.run2(mqttTopic, body);
  }

  public getShadow(id: string, parkId: string) {
    const commandId = this.generateCommandId();
    const mqttTopic = `${id}/commands/${commandId}`;

    const body = this.buildCommand19(commandId, parkId);

    return this.run(mqttTopic, body);
  }

  public getMeta(parkId: string) {
    const commandId = this.generateCommandId();

    const body = this.buildCommand20(commandId, parkId);

    return this.http.post(this.URL, body);
  }

  public sendRaw(parkId: string, command: {}, mqttTopic: string) {
    return this.http.post(this.URL_RAW, {park: parkId, command: command, topic: mqttTopic});
  }

  /**
   *
   * @param {string} id
   * @param {string} parkId
   * @param {boolean} isOn
   * @returns {Promise<any>}
   */
  public switchSplashpadMode(id: string, parkId: string, isOn: boolean) {
    const commandId = this.generateCommandId();
    const mqttTopic = `${id}/commands/${commandId}`;

    const body = this.buildCommand(commandId, parkId, isOn);

    return this.run(mqttTopic, body);
  }

  private run(mqttTopic, body) {
    return new Promise((resolve, reject) => {
      this.aws.connect2().subscribe((conn) => {
        this.aws.messagesObservable.subscribe((msg) => {
          if (msg.topic === mqttTopic && msg.hasOwnProperty('message')) {
            if (msg.message.hasOwnProperty('result')) {
              resolve(msg);
            } else if (msg.message.hasOwnProperty('error')) {
              if (msg.message.error.hasOwnProperty('message') && msg.message.error.hasOwnProperty('data')) {
                if (msg.message.error.message === 'overlap') {
                  reject('overlap');
                } else {
                  reject(msg.message.error.message + ' ' + msg.message.error.data);
                }
              } else if (msg.message.error.hasOwnProperty('code')) {
                if (parseInt(msg.message.error.code, 10) === -1) {
                  reject('Unable to start due to alarm.');
                } else {
                  // console.log(msg)
                  reject(msg.message.error.code);
                }
              } else {
                reject('Error');
              }
            }
          }
        });

        conn.subscribe(mqttTopic, {qos: 1}, (err, granted) => {
          this.http.post(this.URL, body).subscribe((res) => {
            // console.log(res);
          }, (err2) => {
            // console.log(err2);
            reject('Command not sent');
          });
        });
      });
    });
  }

  private run2(mqttTopic, body) {
    return new Promise((resolve, reject) => {
      this.aws.connect2().subscribe((conn) => {
        this.aws.messagesObservable.subscribe((msg) => {
          if (msg.topic === mqttTopic && msg.hasOwnProperty('message')) {
            if (msg.message.hasOwnProperty('result')) {
              if (msg.message.error.hasOwnProperty('code') && parseInt(msg.message.error.code, 10) === -1) {
                reject('Unable to start due to alarm.');
              } else {
                reject(msg.message.error.message + ' ' + msg.message.error.data);
              }
            } else if (msg.message.hasOwnProperty('error')) {
              reject(msg);
            }
          }
        });

        conn.subscribe(mqttTopic, {qos: 1}, (err, granted) => {
          this.http.post(this.URL2, body).subscribe((res) => {
            // console.log(res);
          }, (err2) => {
            // console.log(err2);
            reject('Command not sent');
          });
        });
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/commands.service.ts